<style type="text/css">
#timepicker{
    width: 170px;
}

#timepicker .time-header{
    width: 100%;
    font-size: 30px;
    text-align: center;
    padding: 10px;
    border-bottom: 1px solid #ddd;
    letter-spacing: 2px;
}

#timepicker .time-selector{
    border-bottom: 1px solid #ddd;
}

#timepicker .time-selector .time-list{
    font-size: 25px;
    text-align: center;
    padding: 10px;
    height: 40px;
}

#timepicker .time-selector .time-hour-list{
    border-right: 1px solid #ddd;
}
</style>

<template>
    <div id="timepicker" style="width: 240px;">
        <div class="time-header">
            {{selHour + ':' + selMin}}
        </div>
        <div class="time-selector">
            <vue-scroll ref="hourPicker"
                        class="time-hour-list"
                        style="width: 120px;height: 200px;float: left;"
                        :ops="$onbiLib.scrollOps">
                <div class="time-list"
                     v-for="(hour,index) in hourList"
                     :style="getTimeStyle('hour',hour)"
                     :key="'hour' + index"
                     @click="selTime('hour',hour)">{{hour}}</div>
            </vue-scroll>
            <vue-scroll ref="minPicker"
                        class="time-min-list"
                        style="width: 120px;height: 200px;float: left;"
                        :ops="$onbiLib.scrollOps">
                <div class="time-list"
                     v-for="(min,index) in minuteList"
                     :style="getTimeStyle('min',min)"
                     :key="'min' + index"
                     @click="selTime('min',min)">{{min}}</div>
            </vue-scroll>
        </div>
        <div class="btnWrap">
            <a href="javascript:;"
               class="btn c2"
               style="height: 37px;line-height: 37px;width: 33.3%;"
               @click="btn_cencelClick()">취소</a>
            <a href="javascript:;"
               class="btn c4"
               style="height: 37px;line-height: 37px;width: 33.3%;"
               @click="btn_clearClick()">초기화</a>
            <a href="javascript:;"
               class="btn"
               style="height: 37px;line-height: 37px;width: 33.3%;"
               @click="btn_applyClick()">적용</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'timepicker',
        props: ['popupIndex','params'],
        data: function(){
            return {
                selHour:'00',
                selMin:'00',
                hourList: [],
                minuteList: [],
                clearFunc:null,
                vaildFunc:null,
                applyFunc:null
            }
        },
        methods: {
            getTimeStyle: function(se,time){
                let style = {
                    'background-color':'',
                    'color':'',
                }

                let selAt = false;

                if( (se=='hour'&&time == this.selHour)||
                    (se=='min'&&time == this.selMin)){
                    selAt = true;
                }

                if(selAt){
                    style['background-color'] = '#3B86FF';
                    style['color'] = '#FFFFFF';
                }

                return style;
            },
            selTime: function(se,time){
                if(se=='hour')this.selHour = time;
                else if(se=='min')this.selMin = time;
            },
            btn_cencelClick: function(){
                this.$store.commit('closePopup',this.popupIndex);
            },
            btn_clearClick: function(){
                this.clearFunc(this.params);
                this.btn_cencelClick();
            },
            btn_applyClick: function(){
                this.applyFunc(this.selHour,this.selMin,this.params);
                this.btn_cencelClick();
            }
        },
        mounted: function() {
            for(let i=0; i<60; i++){
                var time = '';
                if(i < 10) time = '0'+i;
                else time = String(i);

                if(i < 24) this.hourList.push(time);
                this.minuteList.push(time);
            }

            this.clearFunc = this.params.clearFunc;
            this.validFunc = this.params.validFunc;
            this.applyFunc = this.params.applyFunc;

            this.selHour = this.params.hour;
            this.selMin = this.params.min;

            const hour = Number(this.selHour);
            const min = Number(this.selMin);

            this.$refs['hourPicker'].scrollTo({y: hour*40},10,'easeInQuad');
            this.$refs['minPicker'].scrollTo({y: min*40},10,'easeInQuad');
        }
    }
</script>

